import { useQuery } from "@tanstack/react-query";
import type React from "react";
import { useEffect } from "react";
import { getMyTrial } from "@/api/profileApi";
import { useSupabaseSession } from "@/hooks/useSupabaseSession";

type TrialGateProps = {
	children: React.ReactNode;
};

export default function TrialGate({ children }: TrialGateProps): React.JSX.Element | null {
	const { session, isLoading: isSessionLoading } = useSupabaseSession();

	const { data: trial, isLoading: isTrialLoading } = useQuery({
		queryKey: ["profile", "trial"],
		queryFn: ({ signal }) => getMyTrial({ signal }),
		enabled: !!session,
		retry: false,
	});

	useEffect(() => {
		if (!session) return;
		if (isTrialLoading) return;
		if (trial?.status !== "PENDING") return;

		if (window.location.pathname !== "/waiting") {
			window.location.href = "/waiting";
		}
	}, [isTrialLoading, session, trial?.status]);

	if (isSessionLoading) return null;
	if (!session) return <>{children}</>;
	if (isTrialLoading) return null;
	if (trial?.status === "PENDING") return null;

	return <>{children}</>;
}
